<template>
  <module-card
    class="profile-card"
    v-bind="params"
    :loading="loading"
    :error="error"
    :permissions="permissions"
    :errorText="errorText"
    :retryFunction="retryFunction"
    :segmentations="segmentations"
    @visibleChanged="$emit('visibleChanged', $event)"
  >
    <template slot="content">
      <v-form
        @submit.prevent="submit"
        v-model="formValid"
        ref="profileCardForm"
        lazy-validation
        class="profile-card__form"
      >
        <text-field
          label="E-mail"
          v-model="item.email"
          class="slin-field"
          :rules="rule.requiredEmail"
          @focus="onEmailFocus"
          append-icon="bexsicon-pencil"
          required
          readonly
        ></text-field>
        <v-layout row wrap>
          <v-flex xs6 class="pr-1">
            <text-field
              type="tel"
              ref="telephone"
              label="Telefone"
              class="slin-field"
              @blur="validatePhones"
              @focus="onTelephoneFocus"
              @change="onTelephoneChange"
              v-model="item.telephone"
              :mask="['(##) ####-####', '(##) #####-####']"
              :rules="[
                                v => (v.length >= 10 || !v) || 'Telefone inválido'
                            ]"
            ></text-field>
          </v-flex>
          <v-flex xs6 class="pl-1">
            <text-field
              type="tel"
              ref="cellphone"
              label="Celular"
              class="slin-field"
              @blur="validatePhones"
              @focus="onCellphoneFocus"
              @change="onCellphoneChange"
              v-model="item.cellphone"
              :mask="['(##) ####-####', '(##) #####-####']"
              :rules="[
                                v => !!v || 'Campo de preenchimento obrigatório',
                                v => (v.length >= 10 || !v) || 'Celular inválido'
                            ]"
              required
            ></text-field>
          </v-flex>
        </v-layout>
      </v-form>

      <v-form
        @submit.prevent="validateEmails"
        v-model="emailValid"
        ref="confirmEmailForm"
        lazy-validation
      >
        <v-dialog v-model="confirmEmailDialog" persistent width="500">
          <v-card>
            <v-card-title
              class="headline lighten-2"
              :style="{ color: params.themeColor }"
              primary-title
            >Editar email</v-card-title>

            <v-card-text>
              <text-field label="E-mail" type="email" v-model="item.email" :rules="rule.requiredEmail" required></text-field>
              <text-field
                label="Confirmar E-mail"
                v-model="confirmEmail"
                type="email"
                :rules="confirmEmailDialog ? confirmEmailRules : []"
                :error="!!errors.emails"
                :error-messages="errors.emails"
                required
              ></text-field>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn @click="cancelEmailChange">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                dark
                :style="{ backgroundColor: params.themeColor }"
                @click="validateEmails"
              >Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>

      <p class="required-disclamer">* Campos obrigatórios</p>
    </template>

    <template slot="actions">
      <v-tooltip
        bottom
        color="grey lighten-3"
        max-width="300"
        class="no-print"
        :disabled="!state.unsavedChanges"
      >
        <v-btn
          class="slin-btn"
          light
          slot="activator"
          @click="submit"
          :style="{ color: state.unsavedChanges
                        ? unsavedChangeColor
                        : params.themeColor
                    }"
        >
          <v-progress-circular
            :color="params.themeColor"
            indeterminate
            :width="3"
            size="24"
            v-if="formLoading"
          ></v-progress-circular>
          <span v-else>
            <i class="unsaved-changes__icon bexsicon-alert" v-show="state.unsavedChanges" />
            <span>Alterar cadastro</span>
          </span>
        </v-btn>
        <span
          v-show="state.unsavedChanges"
          class="unsaved-changes__tooltip"
        >Você tem alterações não salvas.</span>
      </v-tooltip>

      <v-btn
        class="slin-btn"
        @click="$router.push({ name: 'profile' })"
        :style="{ color: params.themeColor }"
      >
        <i :class="`bexsicon-profile-sm`" />
        Ver cadastro completo
      </v-btn>
    </template>
  </module-card>
</template>
<script>
import ModuleCard from '@/components/layout/Card';
import TextField from '@/components/fields/TextField';
import { PROFILES, UNIT, SEGMENTATIONS } from '../../utils/constants';
import enums from '@/utils/enums';

export default {
  name: 'profile-card',

  components: {
    ModuleCard,
    TextField
  },

  computed: {
    hasOnePhone() {
      const { telephone, cellphone } = this.item;

      return telephone.length > 0 || cellphone.length > 0;
    },
    confirmEmailRules() {
      return [
        ...this.rule.requiredEmail,
        v => v == this.item.email || 'Os e-mails não conferem!'
      ];
    },
    segmentations() {
      if (this.isSyndic) {
        return [
          SEGMENTATIONS.SYNDIC__USER_ROLE,
          SEGMENTATIONS.LAUNCH__CONSTRUCTION_STAGE,
          SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE,
          SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE,
          SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE
        ];
      } else {
        const product = this.$store.getters[UNIT.GET_SELECTED_PRODUCT];
        if (product) {
          const constructionStage = enums.constuctionStages[product.stage];
          switch (constructionStage) {
            case 'launch':
              return [
                SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                SEGMENTATIONS.SFH__REHEARSE_STATUS,
                SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                SEGMENTATIONS.LAUNCH__CONSTRUCTION_STAGE
              ];

              break;
            case 'inConstruction':
              return [
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                SEGMENTATIONS.IN_CONSTRUCTION__CONSTRUCTION_STAGE
              ];
              break;
            case 'delivered':
              if (this.$store.getters[UNIT.GET_SELECTED].keyDeliveryDate) {
                return [
                  SEGMENTATIONS.INDIRECT__USER_ROLE,
                  SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE
                ];
              } else {
                return [
                  SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                  SEGMENTATIONS.INDIRECT__USER_ROLE,
                  SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE
                ];
              }
              break;
            default:
              return [];
          }
        } else {
          return null;
        }
      }
    }
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    error: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    formError: {
      type: Boolean,
      required: true
    },
    formLoading: {
      type: Boolean,
      required: true
    },
    state: {
      type: Object,
      default: () => ({})
    },
    errorText: String,
    retryFunction: Function
  },

  data() {
    return {
      confirmEmailDialog: false,
      confirmEmail: '',
      formValid: false,
      emailValid: false,
      beforeConfirmDialogEmailValue: '',
      previousEmail: '',
      previousTelephone: '',
      previousCellPhone: '',
      unsavedChangeColor: '#e68109',
      errors: {
        emails: ''
      },
      permissions: [
        PROFILES.ADMIN_PROFILE,
        PROFILES.ADMIN_BEXS_PROFILE,
        PROFILES.ADMIN_HR_PROFILE,
        PROFILES.HR_PROFILE
      ]
    };
  },

  methods: {
    validatePhones() {
      this.$refs['telephone'].validate();
      this.$refs['cellphone'].validate();
    },

    submit() {
      if (this.$refs.profileCardForm.validate()) {
        this.$emit('submit');
      }
    },

    onEmailFocus(e) {
      e.preventDefault();

      if (!this.previousEmail) this.previousEmail = this.item.email;

      this.beforeConfirmDialogEmailValue = this.item.email;

      this.confirmEmailDialog = true;
    },

    onTelephoneFocus(e) {
      if (!this.previousTelephone) this.previousTelephone = this.item.telephone;
    },

    onCellphoneFocus(e) {
      if (!this.previousCellPhone) this.previousCellPhone = this.item.cellphone;
    },

    onTelephoneChange(e) {
      if (
        !this.state.unsavedChanges &&
        e.target.value != this.previousTelephone
      ) {
        this.state.unsavedChanges = true;
      }
    },

    onCellphoneChange(e) {
      if (
        !this.state.unsavedChanges &&
        e.target.value != this.previousCellPhone
      ) {
        this.state.unsavedChanges = true;
      }
    },

    validateEmails() {
      if (!this.$refs.confirmEmailForm.validate()) return;

      if (this.confirmEmail != this.item.email) {
        this.errors.emails = 'Os e-mails não conferem!';
        return;
      }

      this.confirmEmail = '';
      this.errors.emails = '';
      this.beforeConfirmDialogEmailValue = this.item.email;
      this.confirmEmailDialog = false;

      if (!this.state.unsavedChanges && this.item.email != this.previousEmail) {
        this.state.unsavedChanges = true;
      }

      this.submit();
    },

    cancelEmailChange() {
      this.confirmEmail = '';
      this.errors.emails = '';
      this.item.email = this.beforeConfirmDialogEmailValue;
      this.confirmEmailDialog = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.required-disclamer {
  padding: 2px 0;
  font-size: 0.75em;
}

.unsaved-changes__icon {
  font-size: 12px;
  padding: 0 !important;
}

.unsaved-changes__tooltip {
  color: #e68109;
}

.unsaved-changes__text {
  font-size: 9px;
}

.profile-card {
  >>> .v-card__text {
    padding: 0 16px !important;
  }

  &__form {
    @include breakpoint(mobile) {
      margin: -16px 0 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/components/modules/ProfileCard.vue